// extracted by mini-css-extract-plugin
module.exports = {"servicesPadding":"Review_servicesPadding__UEhdp"};